
const baseUrl = {
    // admin: 'http://116.255.236.229:8494/',
    admin: 'https://api.xszg.cc/wm/',
    basic: 'https://api.xszg.cc/wb/',
}

export default baseUrl